var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-app-bar",
        {
          staticClass: "contract-application-toolbar pl-0",
          staticStyle: { "background-color": "white" },
          attrs: { flat: "", dense: "", height: "60" }
        },
        [
          _c("v-col", { staticClass: "pa-0 ma-0", attrs: { cols: "4" } }, [
            _c(
              "div",
              [
                _c("v-img", {
                  attrs: { src: "/static/logo.png", width: "350" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("v-col", { staticClass: "text-center", attrs: { cols: "4" } }, [
            _c("h1", { staticClass: "title" }, [
              _vm._v(
                "\n                " + _vm._s(_vm.title) + "\n            "
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66f17322", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66f17322","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globals/AppHeader.vue
// module id = VwSY
// module chunks = 1